import { routeAdjustmentManager } from "@/setup/routes/adjustment.routes";
import { useShiftNavigator } from "@dexteel/mesf-core";
import { Tooltip } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";
import { useNavigate } from "react-router-dom";

export const AdjustmentTag = (params: ICellRendererParams) => {
	const navigate = useNavigate();
	const { shiftInfo } = useShiftNavigator();

	const value = params.value?.name;
	const id = params.value?.id;

	if (!value) {
		return null;
	}

	if (value !== "Adjustment") {
		return value;
	}

	return (
		<Tooltip
			title={value}
			onClick={() => {
				navigate(
					`${routeAdjustmentManager}/${shiftInfo?.CurrentShiftId}?adjustmentId=${id}`,
				);
			}}
			arrow
		>
			<div
				style={{
					backgroundColor: "red",
					width: "26px",
					height: "26px",
					borderRadius: 4,
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					color: "#fff",
					fontWeight: "bold",
				}}
			>
				{value.charAt(0).toUpperCase()}
			</div>
		</Tooltip>
	);
};
